import { CustomerPortalTheme } from "Models/customerPortalTheme";
import {
  createCustomerPortalThemeFromDatabase,
  customerPortalDefaultTheme,
  CustomerPortalThemeType,
} from "Themes/customerPortalTheme";
import { create } from "zustand";

interface CustomerPortalStore {
  theme: CustomerPortalThemeType;
  setThemeFromDatabase: (themeFromDatabase: CustomerPortalTheme) => void;
  setTheme: (newTheme: CustomerPortalThemeType) => void;
}

const useCustomerPortalStore = create<CustomerPortalStore>((set) => ({
  theme: customerPortalDefaultTheme,
  setThemeFromDatabase: (themeFromDatabase) => {
    const savedTheme = createCustomerPortalThemeFromDatabase(themeFromDatabase);

    set(() => ({ theme: savedTheme }));
  },
  setTheme: (newTheme) => set({ theme: newTheme }),
}));

export { useCustomerPortalStore };
